import { render, staticRenderFns } from "./ReleasePending.vue?vue&type=template&id=46bdd222&scoped=true&"
import script from "./ReleasePending.vue?vue&type=script&lang=js&"
export * from "./ReleasePending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bdd222",
  null
  
)

export default component.exports